import { render, staticRenderFns } from "./DisputeResolutionMessagesEscalated.vue?vue&type=template&id=42cec938&scoped=true&"
import script from "./DisputeResolutionMessagesEscalated.vue?vue&type=script&lang=js&"
export * from "./DisputeResolutionMessagesEscalated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cec938",
  null
  
)

export default component.exports